/** 页面信息 */
const page = new (function () {
  this.title = '环境行政处罚案件'
  this.icon = 'iconfont iconicon_group'
  this.name = 'punish_history'
  /**菜单编号 */
  this.code = 'punish_history'
  /**菜单别名 */
  this.aliasName = 'punish_history'
  /**路由地址 */
  this.path = '/fill/in/punish/history'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
